import { createFileRoute } from '@tanstack/react-router';

import { authorizationSearch, authorizationsScreen, loadDataprevEmployeeMessages, loadDataprevEmployeeScreens } from '@/modules/dataprev-employee/route';
import { lazyScreen } from '@/shared/screen';

// Gestão de autorizações no caminho do legado (`router.tsx:1299-1309`): o menu passa a apontar para cá
// quando o manifesto entra em `src/app/screens.ts`. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/ccb/gestao-autorizacoes/')({
  validateSearch: authorizationSearch,
  staticData: { screen: authorizationsScreen },
  loader: () => loadDataprevEmployeeMessages(),
  component: lazyScreen(loadDataprevEmployeeScreens, 'AuthorizationRouteScreen'),
});
